import { Injectable } from '@angular/core';
import { PermissionsApi } from '../../api/permissions/permissions.api';
import { PAETEPRoleType } from '../../model/enum/paetep-role-types.enum';
import { EditRolePermissionsDTO } from 'src/app/model/permissions/edit-role-permissions-dto.model';

@Injectable()
export class PermissionsService {

    constructor(private permissionsApi: PermissionsApi) { }

    getMyPermissions = () => this.permissionsApi.getMyPermissions();
    getRolesICanManage = () => this.permissionsApi.getRolesICanManage();
    getRolesICanManagePerBuilding = () => this.permissionsApi.getRolesICanManagePerBuilding();
    getPermissions = (roleIds?: PAETEPRoleType[], portalId?: number) => this.permissionsApi.getPermissions(roleIds, portalId);
    updateRolePermissions = (editRolePermissionsDTO: EditRolePermissionsDTO) => this.permissionsApi.updateRolePermissions(editRolePermissionsDTO);
}